module.exports = {
  "country": "FR",
  "artist": "Barbara Pravi",
  "song": "Voila",
  "year": "2021",
  "place": "2",
  "spotify": "1uAOCTevGnyKIDbgZdOCnE"
};